import Vue from 'vue'
import Router from 'vue-router'


import Index from '@/views/home/index'
import About from '@/views/about/about'
import Query from '@/views/query/query'
import QueryDetails from '@/views/query/queryDetails'
import UserAgreement from '@/views/agreement/UserAgreement'
import ResourceManage from '@/views/resourceManage/resourceManage'
import TeamDetail from '@/views/other/teamDetail'
import NewDetail from '@/views/other/newDetail'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: '/',
  routes: [
    {
      path: '',
      redirect: '/index',
      meta: {
        keepAlive: false,
      }
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/query',
      name: 'query',
      component: Query,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/queryDetails',
      name: 'queryDetails',
      component: QueryDetails,
      meta: {
        keepAlive: false,
      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/userAgreement',
      name: 'userAgreement',
      component: UserAgreement,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/resourceManage',
      name: 'resourceManage',
      component: ResourceManage,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/teamDetail',
      name: 'teamDetail',
      component: TeamDetail,
      meta: {
        keepAlive: false
      }
    },
    {
      path: '/newDetail',
      name: 'newDetail',
      component: NewDetail,
      meta: {
        keepAlive: false
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js